import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Radio } from 'antd';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionAction } from '@hooks/useSessionAction';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { ACTION_REFF2F_CODE } from '@components/Clinicians/session-form';

export const FaceToFaceUrgencyFormItem = ({ disabled = false }) => {
  const { t } = useTranslation('common');
  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();

  const { URGENCY_KEY, selectedSubTypeMeta } = useSessionAction(ACTION_REFF2F_CODE);

  const [urgency, setUrgency] = useSessionFormState(URGENCY_KEY);

  const options = selectedSubTypeMeta?.action_urgency_codes?.map((value, i) => ({
    value,
    label: selectedSubTypeMeta?.action_urgency_desc?.[i]
  }));

  const defaultUrgency = selectedSubTypeMeta?.action_urgency_codes?.[0];

  useEffect(() => {
    if (!urgency && defaultUrgency) {
      setUrgency(defaultUrgency);
    }
  }, [urgency, defaultUrgency]);

  // When urgency is not required for the current subtype, the B/E may provide a single default option
  if (options?.length === 1 && !isCompleted && !readonly) {
    setUrgency(options[0].value);

    return null;
  }

  return (
    <SessionFormItem label={t('Urgency')} name={URGENCY_KEY} required isGroupField>
      <Radio.Group
        onChange={(e) => setUrgency(e.target.value)}
        value={urgency}
        disabled={isCompleted || readonly || !options || options?.length === 0 || disabled}
        options={options}
      />
    </SessionFormItem>
  );
};
